import * as React from "react";
import styles from "./CardImage.scss";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
    src?: string;
    className?: string;
}

class CardImage extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    private backgroundImage = { backgroundImage: `url('${this.props.src}')` };

    public render() {
        return (
            <div className={`${styles.cardImage} ${this.props.className}`} style={this.backgroundImage} />
        );
    }
}

export default CardImage;


// WEBPACK FOOTER //
// ./src/Components/Common/Card/CardImage/CardImage.tsx